// Configuración pública del proyecto Firebase (no es secreta).
export const firebaseConfig = {
  apiKey: "AIzaSyDxPAVuNxXQ4Q2yCngz161Kq0yVIIG6SOU",
  authDomain: "inquiapp-a453e.firebaseapp.com",
  projectId: "inquiapp-a453e",
  storageBucket: "inquiapp-a453e.firebasestorage.app",
  messagingSenderId: "157649625956",
  appId: "1:157649625956:web:9c78ada55074ab39761071"
};

// Modelos de Gemini para leer fotos/documentos (se prueba en orden).
export const GEMINI_MODELOS = ["gemini-2.5-flash", "gemini-flash-latest"];
